import React from "react";
import { observer } from "mobx-react";
import { Dialog, DialogContent, IconButton, Box, Alert } from "@mui/material";
import { CloseIcon } from "../../icons";
interface PDFViewerDialogProps {
  open: boolean;
  onClose: () => void;
  pdfUrl: string;
  title?: string;
  warning?: string;
}

export const PDFViewerDialog: React.FC<PDFViewerDialogProps> = observer(
  ({ open, onClose, pdfUrl, title, warning }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        fullWidth
        // Sobre la banda de modales/mini-forms (10100-10300) para quedar por
        // encima del modal que lo abrió; debajo de tooltip/snackbar (10400).
        sx={{ zIndex: 10350 }}
        PaperProps={{
          sx: {
            width: "95vw",
            height: "95vh",
            maxWidth: "95vw",
            maxHeight: "95vh",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Box sx={{ pl: 1, fontWeight: 500 }}>{title || "Documento PDF"}</Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        {warning && (
          <Alert severity="warning" sx={{ borderRadius: 0 }}>
            {warning}
          </Alert>
        )}
        <DialogContent sx={{ p: 0, height: "100%" }}>
          <iframe
            src={pdfUrl}
            style={{ width: "100%", height: "100%", border: "none" }}
            title={title || "PDF Viewer"}
          />
        </DialogContent>
      </Dialog>
    );
  }
);
